window._ = require('lodash');
// import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;
window.axios.defaults.withXSRFToken = true;

window.isMac = (navigator.appVersion.indexOf('Mac') != -1);

import Pikaday from 'pikaday';

window.Pikaday = Pikaday;

import Cropper from 'cropperjs';

window.Cropper = Cropper;

import NProgress from 'nprogress';

import { colord } from 'colord';
window.colord = colord;

// import Alpine from 'alpinejs';
import intersectClass from 'alpinejs-intersect-class';
if (window.Alpine) {
    window.Alpine.plugin(intersectClass);
}

import sort from '@alpinejs/sort';
if (window.Alpine) {
    window.Alpine.plugin(sort);
}

import Sortable from 'sortablejs';
window.Sortable = Sortable;

// Livewire.start();

// if (Livewire !== undefined) {
//     Livewire.hook('message.failed', (message, component) => {
//         const statusCode = component.latestErrorResponse?.status || 'Unknown';
//         console.log('Livewire.onError1', message, statusCode, component);
//         if (statusCode >= 500) {
//             window.location.reload();
//         }
//         return false;
//     });
// }
// document.addEventListener('livewire:load', function () {
//     if (Livewire !== undefined) {
//         Livewire.hook('message.failed', (message, component) => {
//             const statusCode = component.latestErrorResponse?.status || 'Unknown';
//             console.log('Livewire.onError2', message, statusCode, component);
//             if (statusCode >= 500) {
//                 window.location.reload();
//             }
//             return false;
//         });
//     }
// });

document.addEventListener('livewire:init', function () {
    if (Livewire) {
        Livewire.hook('commit', ({ component, commit, respond, succeed, fail }) => {
            NProgress.start()
            succeed(({ spanshot, effect }) => {
                queueMicrotask(() => {
                    NProgress.done(true)
                    NProgress.remove()
                })
                // Clear the once-per-page reload latch so a single historical 419
                // can't permanently disable the safety net.
                window.localStorage.removeItem('livewire-error');
            })
        });
        Livewire.hook('request', ({ fail }) => {
            fail(({ status, preventDefault }) => {
                // 419 = expired session; 500+ = server error. Both reload once.
                if (status === 419 || status >= 500) {
                    // Always suppress Livewire's built-in "page expired" alert.
                    preventDefault();
                    if (!window.localStorage.getItem('livewire-error') && window.location.hostname !== 'tba-qikcms.test') {
                        window.localStorage.setItem('livewire-error', '1');
                        window.location.reload();
                    }
                }
            })
        });
    }
});

require('./splide');
